export interface ActivityType extends NamedApiEntity {
  vacancyType: VacancyType
  parentId?: id
}

export async function fetchActivityTypes() {
  const {
    attributes: activityTypes,
    pending,
    refresh,
  } = await useApiFetch<ActivityType[]>('/api/v1/activity_types')

  return {
    activityTypes,
    pending,
    refresh,
  }
}
